import React from 'react'
import BaseWidget from './BaseWidget'
import type { BaseWidgetProps } from './BaseWidget'

const ContactLogSearchCard: React.VFC<BaseWidgetProps> = (props: BaseWidgetProps) => <BaseWidget {...props} />

export default ContactLogSearchCard
export type { BaseWidgetProps as ContactLogSearchCardProps }
